<template>
    <div class="listingCard">
        <div class="seriel-number"><h1>{{ v.prno }}</h1></div>
        <div :class="['title-and-content', v.locked ? 'locked' : '' ]">
            <div class="locker-area cursor-pointer" v-if="v.locked" @click="openDetail(v.detailUrl)">
                <h1><span class="iconify" data-icon="clarity:lock-solid" data-height="50px" data-inline="false"></span> Upgrade To Unlock</h1>
            </div>
            <div class="title-and-date">
                <h3 class="text-capitalize text-truncate"  data-bs-toggle="tooltip" data-bs-placement="bottom" :title="v.title">{{ v.title }}</h3>
                <i>{{ v.added_date }}</i>
            </div>
            <div class="products-rates">
                <InfoBox title="CPC" :val="v.cpc" :content="hc.text_cpc" :locked="v.locked"/>
                <InfoBox title="Volume" :val="$filters.humanNumber(v.volume)" :content="hc.text_volume" :locked="v.locked"/>
                <InfoBox title="Country" :val="v.country_code.toUpperCase()" :content="$filters.initCap(v.country_name)" :locked="v.locked"/>
                <InfoBox title="Competition" :val="v.competition" :content="hc.text_competition" :locked="v.locked"/>
            </div>
            <div>
              <a href="javascript:void(0);" class="show-details-btn" data-bs-toggle="modal" data-bs-target="#authModal" v-if="isGuest">Show Details</a>
              <inertia-link v-else :href="v.detailUrl" class="show-details-btn">Show Details</inertia-link>
            </div>
        </div>
        <div :class="'status ' + ((v.rating_color || 'plus').includes('danger') ? 'minus' : 'plus')">
            <InfoRating
                        :trend-icon="v.rating_icon || null"
                        :trend-color="v.rating_color || null"
                        :val="v.rating"
                        :content="($page.props.data.productType == 'weekly' ? hc.text_rating_weekly : hc.text_rating)"
                        :locked="false"
                        :updating="$page.props.isTrendUpdating"
            />
        </div>
        <div class="save-btn">
            <Bookmark :type="isGuest ? 'guest' : 'list'" :product-title="v.title" :is-winning="v.is_winning" :id="v.id" :is-bookmark="v.bookmarked" :key="v.id+v.bookmarked" />
        </div>
        <div class="img">
            <div class="locked-area cursor-pointer" v-if="v.locked" @click="openDetail(v.detailUrl)">
                <span class="iconify" data-height="50px" data-icon="dashicons:lock-alt" data-inline="false"></span>
            </div>
            <img onerror="this.onerror=null;this.src='/images/default/product.png'" :src="v.featured_image" :alt="v.title" loading="lazy" />
        </div>
    </div>
</template>

<script>
import PageLoading from "./PageLoading";
import Pagination from "@s/Components/Inertia/IPagination";
import Bookmark from "./Bookmark";
import DateRangeButton from "@s/Components/DateRangeButton";
import InfoRating from "./InfoRating";
import InfoBox from "./InfoBox";

export default {
    name: "List",
    components: {
        DateRangeButton,
        PageLoading,
        'pagination': Pagination,
        Bookmark, InfoRating, InfoBox,
    },
    data() {
        return {
            hc: __st.hc,
        }
    },
    props: {
      v: { required: true },
      isGuest: { default: false},
    },
    methods: {
        openDetail(url) {
            location.href = url;
        }
    }
}
</script>
